import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class TicketService {
  dbTicket = firebase.firestore().collection('tickets');
  constructor(private httpClient: HttpClient) {}

  createTicket(bookingId) {
    return this.httpClient.post(`${environment.apiUrl}/createTicketByBooking`, {
      bookingId: bookingId
    });
  }

  getOneById(ticketId) {
    return this.dbTicket.doc(ticketId).get();
  }

  add(data) {
    return this.dbTicket.add(data);
  }

  update(id, data) {
    return this.dbTicket.doc(id).update(data);
  }

  getByUserId(userId) {
    return this.dbTicket.where('userId', '==', userId).get();
  }

  queryDataRealtime(key: string, pala, value) {
    return this.dbTicket.where(key, pala, value);
  }

  queryDataRealtimeAll() {
    return this.dbTicket;
  }

  sentmail(data) {
    return this.httpClient.post(
      'https://us-central1-psg-web-8a748.cloudfunctions.net/api/sentmail',
      data
    );
  }
}
